import { BrowserIcon, InspectIcon, PlusOutlineIcon } from '@carboncopyco/icons';
import type { Tour } from '@carboncopyco/types';
import {
  Button,
  ColorHex,
  Dropdown as DropdownComponent,
  Separator,
} from '@carboncopyco/ui';
import { useState } from 'react';
import CreateTourFromAnImage from './CreateTourFromAnImage/CreateTourFromAnImage';
import DropdownItem from './DropdownItem';

interface IDropdown {
  selectedFrameIndex: number;
  isCaptureFromDemoDisabled: boolean;
  tour: Tour;
  onDropdownButtonClick: () => void;
  onFromADemoClick: () => void;
  onFromALiveAppClick: () => void;
}

const Dropdown = ({
  selectedFrameIndex,
  isCaptureFromDemoDisabled,
  tour,
  onDropdownButtonClick,
  onFromADemoClick,
  onFromALiveAppClick,
}: IDropdown) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };
  return (
    <DropdownComponent
      align="start"
      width={341}
      open={isDropdownOpen}
      onInteractOutside={closeDropdown}
      asChild
      triggerElement={
        <Button
          dark
          icon={<PlusOutlineIcon />}
          onClick={() => {
            setIsDropdownOpen(true);
            onDropdownButtonClick();
          }}
        />
      }
    >
      <DropdownItem
        title="From a live app"
        subtitle="Capture from a live product or website"
        onClick={() => {
          closeDropdown();
          onFromALiveAppClick();
        }}
        icon={<InspectIcon size={24} />}
      />
      <Separator horizontal />
      <DropdownItem
        title="From a demo"
        subtitle="Capture from any existing demo"
        onClick={() => {
          closeDropdown();
          onFromADemoClick();
        }}
        isDisabled={isCaptureFromDemoDisabled}
        disabledMessage="Once you'll have a demo you can capture a Tour from it."
        icon={
          <BrowserIcon
            size={24}
            color={
              isCaptureFromDemoDisabled
                ? ColorHex.natural200
                : ColorHex.natural600
            }
          />
        }
      />
      <Separator horizontal />
      <CreateTourFromAnImage
        onClose={closeDropdown}
        selectedFrameIndex={selectedFrameIndex}
        tour={tour}
      />
    </DropdownComponent>
  );
};

export default Dropdown;
